import { Editor } from 'roosterjs-editor-core';
import {
    PluginEvent,
    ContentChangedEvent,
    ChangeSource,
    PluginEventType,
} from 'roosterjs-editor-types';

export default function pasteOptionPluginTrigger(evt: PluginEvent, editor: Editor) {
    return (
        evt.eventType === PluginEventType.ContentChanged &&
        (<ContentChangedEvent>evt).source == ChangeSource.Paste
    );
}
